<template>
    <div>
        <div class="filter-header row d-none d-sm-flex">
            <div class="col-md-12 col-sm-12 col-12">
                <p class="pull-left m-lg-top text-to-increase">{{t('Discover your next skill')}}</p>
                <a href="javascript:" @click="$emit('input', null)"
                   :style="{color: colorFilter}"
                   class="pull-right m-lg-top">{{t('Clear Filters')}}</a>
            </div>
        </div>
        <form class="filters-form">
            <div class="row">
                <div class="col-md-12 col-sm-12 col-12">
                    <ul class="list-inline first-row">
                        <li class="pl-0 p-md-right list-inline-item mr-0">
                            <div class="form-group mb-0">
                                <label>{{t('Mode')}}</label>
                            </div>
                            <div class="btn-group" data-toggle="buttons">
                                <i class="bg-filter-online"
                                   @click="changeMode('online')"
                                   :class="{'active': _.get(value, 'mode', null) === 'online'}"></i>
                                <i class="bg-filter-onsite"
                                   @click="changeMode('onsite')"
                                   :class="{'active': _.get(value, 'mode', null) === 'onsite'}"></i>
                                <i class="bg-filter-blended"
                                   @click="changeMode('blended')"
                                   :class="{'active': _.get(value, 'mode', null) === 'blended'}"></i>
                            </div>
                        </li>

                        <li class="pl-0 list-inline-item mr-0">
                            <div class="form-group">
                                <label>{{t('Type')}}</label>
                                <select id="type"
                                        v-model="typeValue"
                                        :style="corporationStyles"
                                        class="form-control type-select">
                                    <option value="">{{t('All')}}</option>
                                    <option value="Online">{{t('Online')}}</option>
                                    <option value="Onsite">{{t('Onsite')}}</option>
                                    <option value="Blended">{{t('Blended')}}</option>
                                </select>
                            </div>
                        </li>
                        <li class="pl-0 list-inline-item mr-0">
                            <div class="form-group">
                                <label>{{t('Level')}}</label>
                                <select id="level"
                                        v-model="levelValue"
                                        :style="corporationStyles"
                                        class="form-control type-level">
                                    <option value="">{{t('All')}}</option>
                                    <option value="Beginner">{{t('Beginner')}}</option>
                                    <option value="Intermediate">{{t('Intermediate')}}</option>
                                    <option value="Advanced">{{t('Advanced')}}</option>
                                </select>
                            </div>
                        </li>
                        <li class="pl-0 list-inline-item mr-0">
                            <div class="form-group">
                                <label>{{t('Language')}}</label>
                                <select id="language"
                                        v-model="languageValue"
                                        :style="corporationStyles"
                                        class="form-control type-language">
                                    <option value="">{{t('All')}}</option>
                                    <option value="English">{{t('English')}}</option>
                                    <option value="French">{{t('French')}}</option>
                                    <option value="Spanish">{{t('Spanish')}}</option>
                                    <option value="German">{{t('German')}}</option>
                                </select>
                            </div>
                        </li>

                        <li class="pl-0  list-inline-item mr-0">
                            <div class="form-group mb-0">
                                <label>{{t('Age')}}</label>
                            </div>
                            <div class="btn-group" data-toggle="buttons">
                                <label :class="{active: _.get(value, 'age', null) === 'adult' }"
                                       @click="changeAge('adult')"
                                       :style="corporationStyles"
                                       class="btn p-md-left-right mb-0">
                                    {{t('Adult')}}
                                </label>
                                <label :class="{active: _.get(value, 'age', null) === 'kids' }"
                                       @click="changeAge('kids')"
                                       :style="corporationStyles"
                                       class="btn p-md-left-right mb-0">
                                    {{t('Kids')}}
                                </label>
                            </div>
                        </li>
                        <li class="pl-0 list-inline-item mr-0">
                            <div class="form-group">
                                <label>{{t('Categories')}}</label>
                                <select id="topics"
                                        :style="corporationStyles"
                                        class="form-control topics-select">
                                    <option value="">{{t('All')}}</option>
                                    <option v-for="topic in topics" :value="topic.id">{{topic.name}}</option>
                                </select>
                            </div>
                        </li>


                        <li class="pl-0 price-item list-inline-item mr-0" style="top: 0;">
                            <div class="form-group">
                                <div class="col-6" style="float: left;">
                                    <label>{{t('Price')}}</label>
                                </div>
                                <div class="col-6" style="float: right;">
                                    <label>{{t('Currency')}}</label>
                                </div>
                                <div class="price-group">
                                    <div class="input-group">
                                        <input  type="number" v-model.number="priceValue"
                                                :style="corporationStyles"
                                                class="form-control" v-bind:placeholder="t('Up to $100')" min="0">
                                        <span class="input-group-btn">
                                            <button type="button"
                                                    :style="corporationStyles"
                                                    class="btn btn-default p-sm-right">
                                                CAD
                                            </button>
                                            <!--ul class="dropdown-menu dropdown-menu-right">
                                              <li><a href="javascript:">CAD</a></li>
                                              <li><a href="javascript:">Dls</a></li>
                                           </ul-->
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>

            <div class="row">
                <div class="col-md-12 col-sm-12 col-12">
                    <ul class="list-inline">
                        <li class="p-md-right list-inline-item mr-0">
                            <div class="form-group">
                                <label for="starts">{{t('Starts')}}</label>
                                <select id="starts" v-model="startsValue"
                                        :style="corporationStyles"
                                        class="form-control starts-select">
                                    <option value="">{{t('All')}}</option>
                                    <option value="this week">{{t('This week')}}</option>
                                    <option value="next month">{{t('Next week')}}</option>
                                    <option value="this month">{{t('This Month')}}</option>
                                </select>
                            </div>
                        </li>

                        <li class="pl-0 list-inline-item mr-0">
                            <div class="form-group location-group">
                                <label for="location">{{t('At this location')}}</label>
                                <!--location-input-search
                                        :location-value="locationValue"
                                        :do-search="doSearch"
                                        :locations="locations">
                                </location-input-search -->
                                <input type="text" v-bind:placeholder="t('In this City, Country')"
                                       :style="corporationStyles"
                                       class="form-control">
                                <!--i class="bg-out"></i-->
                            </div>
                        </li>

                        <li class="pl-0 list-inline-item mr-0">
                            <div class="form-group mb-0">
                                <label>{{t('In the')}}</label>
                            </div>
                            <div class="btn-group" data-toggle="buttons">
                                <label :class="{active: _.get(value, 'time_inthe', null) === 'Morning' }"
                                        @click="changeInThe('Morning')"
                                       :style="corporationStyles"
                                       class="btn mb-0">
                                    {{t('Morning')}}
                                </label>
                                <label :class="{active: _.get(value, 'time_inthe', null) === 'Afternoon' }"
                                       @click="changeInThe('Afternoon')"
                                       :style="corporationStyles"
                                       class="btn mb-0">
                                    {{t('Afternoon')}}
                                </label>
                                <label :class="{active: _.get(value, 'time_inthe', null) === 'Night' }"
                                       @click="changeInThe('Night')"
                                       :style="corporationStyles"
                                       class="btn mb-0">
                                    {{t('Night')}}
                                </label>
                            </div>
                        </li>

                        <li class="pl-0 list-inline-item mr-0">
                            <div class="form-group mb-0">
                                <label>{{t('On')}}</label>
                            </div>
                            <div class="btn-group" data-toggle="buttons">
                                <label :class="{active: _.get(value, 'time_on', null) === 'weekly' }"
                                       @click="changeTimeOn('weekly')"
                                       :style="corporationStyles"
                                       class="btn mb-0">
                                    {{t('Weeks')}}
                                </label>
                                <label :class="{active: _.get(value, 'time_on', null) === 'weekend' }"
                                       @click="changeTimeOn('weekend')"
                                       :style="corporationStyles"
                                       class="btn mb-0">
                                    {{t('Weekends')}}
                                </label>
                            </div>
                        </li>
                        <!--li class="pl-0  list-inline-item mr-0">
                            <div class="form-group">
                                <label>{{t('Duration')}}</label>
                                <select id="duration" class="form-control type-duration">
                                    <option value="">{{t('All')}}</option>
                                </select>
                            </div>
                        </li-->
                    </ul>
                </div>
            </div>
        </form>
    </div>

</template>

<script>
export default {
    name: "FiltersPanel",
    props: {
        value: {
            type: Object
        }
    },
    data() {
        return {
            topics: [],
            inputTimeout: null,
            priceValue: null,
            typeValue: _.get(this.value, 'mode', ''),
            startsValue: _.get(this.value, 'starts', ''),
            languageValue: _.get(this.value, 'language', ''),
            levelValue: _.get(this.value, 'level', ''),
        }
    },
    watch: {
        typeValue(type) {
            this.assignFilter({mode: type});
        },
        startsValue(newVal) {
            this.assignFilter({starts: newVal});
        },
        languageValue(newVal) {
            this.assignFilter({language: newVal});
        },
        levelValue(newVal) {
            this.assignFilter({level: newVal});
        },
        value() {
            this.typeValue = _.get(this.value, 'mode', '');
            this.startsValue = _.get(this.value, 'starts', '');
            this.languageValue = _.get(this.value, 'language', '');
            this.levelValue = _.get(this.value, 'level', '');
        }
    },
    computed: {
        _() {
            return _;
        },
        corporationStyles() {
            let styles = {};
            const filtersColor = _.get(this.$parent, 'corporation.color_filters', null);

            if (filtersColor) {
                styles.borderColor = filtersColor;
            }

            return styles;
        },
        colorFilter() {
            return _.get(this.$parent, 'corporation.color_filters', null);
        }
    },
    methods: {
        changeAge(newValue) {
            this.assignFilter({age: newValue});
        },
        changeTimeOn(newValue) {
            this.assignFilter({time_on: newValue});
        },
        changeInThe(newValue) {
            this.assignFilter({time_inthe: newValue});
        },
        changeMode(newMode) {
            this.assignFilter({mode: newMode});
        },
        assignFilter(params) {
            const filters = this.value ? _.cloneDeep(this.value) : {};
            Object.assign(filters, params);
            this.$emit('input', filters);
        },
        handlePriceInput: function () {
            if (this.inputTimeout) {
                clearTimeout(this.inputTimeout);
            }

            this.inputTimeout = setTimeout(function(){
                this.assignFilter({price: this.priceValue});
            }.bind(this), 400);
        }
    }
}
</script>

<style scoped>

</style>
